import React, { useEffect, useState } from 'react'
import ToastComponent from 'src/components/common/TaostComponent'
import CommonService from 'src/service/CommonService'
import moment from 'moment'
import {
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from '@coreui/react-pro'
import ShowPricingQuotaModelForLeague from './ShowPricingQuotaModelForLeague'
import ShowPricingQuotaModelForGame from './ShowPricingQuotaModelForGame'

const GameQuoteRequest = () => {
  const [pricingQuoteRecords, setPricingQuoteRecords] = useState([])
  const [pricingRequestData, setPricingRequestData] = useState({})
  const [gameInfo, setGameInfo] = useState({})
  const getPricingQuoteData = React.useCallback(() => {
    CommonService.getAdminPricingQuoteRecords()
      .then((res) => {
        if (res.status === 200) {
          setPricingQuoteRecords(res.data)
        }
      })
      .catch((e) => {
        console.log('Error fetching pricing quote:', e)
        ToastComponent('Something went wrong. Please try again.', 'error')
      })
  }, [])

  useEffect(() => {
    getPricingQuoteData()
  }, [getPricingQuoteData])

  const getBadge = (status) => {
    switch (status) {
      case 1:
        return 'success'
      case 2:
        return 'danger'
      default:
        return 'warning'
    }
  }

  const handleStatus = (id, status) => {
    CommonService.changeQuoteRequestStatus(id, status)
      .then((res) => {
        if (res.status === 200) {
          getPricingQuoteData()
          ToastComponent(res.message, 'success')
        }
      })
      .catch((e) => {
        console.log('Catch Block', e)
      })
  }
  const gameTypeLabels = {
    1: 'Season Game',
    2: 'Tournament Game (For Leagues)',
    3: 'Tournament Game (For Indoor Leagues)',
    4: 'Match Contest',
  }
  const showPricingQuote = (id, status) => {
    CommonService.changeQuoteRequestStatus(id, status)
      .then((res) => {
        if (res.status === 200) {
          getPricingQuoteData()
          ToastComponent(res.message, 'success')
        }
      })
      .catch((e) => {
        console.log('Catch Block', e)
      })
  }
  const [visible, setVisible] = useState(false)
  const [quoteRecordDetails, setQuoteRecordDetails] = useState({})
  const [pricingQuoteVisibleModal, setPricingQuoteVisibleModal] = useState(false)
  const getGameRequestQuoteData = (id, gameId) => {
    CommonService.getGameInfoFromGameId(gameId).then((res) => {
      if (res.status === 200) {
        setGameInfo(res?.game_info)
      }
    })
    setQuoteRecordDetails({ gameId: gameId, recordId: id })
    setPricingQuoteVisibleModal(true)
  }

  return (
    <>
      <CCard>
        <CCardHeader>
          <strong>Done For You</strong>
        </CCardHeader>
        <CCardBody>
          <CTable>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell scope="col">SN</CTableHeaderCell>
                <CTableHeaderCell scope="col">Hub Name</CTableHeaderCell>
                <CTableHeaderCell scope="col">Game Name</CTableHeaderCell>
                <CTableHeaderCell scope="col">Game Type</CTableHeaderCell>
                <CTableHeaderCell scope="col">Team Tiers</CTableHeaderCell>
                <CTableHeaderCell scope="col">Amount</CTableHeaderCell>
                <CTableHeaderCell scope="col">ScoreMail Block</CTableHeaderCell>
                <CTableHeaderCell scope="col">Status</CTableHeaderCell>
                <CTableHeaderCell scope="col">Request on</CTableHeaderCell>
                <CTableHeaderCell scope="col">Action</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {pricingQuoteRecords.map((record, index) => (
                <CTableRow key={index}>
                  <CTableHeaderCell scope="row">{index + 1}</CTableHeaderCell>
                  <CTableDataCell>{record.club_name}</CTableDataCell>
                  <CTableDataCell>{record.game_name}</CTableDataCell>
                  <CTableDataCell>{gameTypeLabels[record.game_type] || '-'}</CTableDataCell>
                  <CTableDataCell>
                    <CButton
                      size="sm"
                      color="info"
                      className="me-2"
                      onClick={() => getGameRequestQuoteData(record?.id, record.game_id)}
                    >
                      {record.plan_name}
                    </CButton>
                  </CTableDataCell>
                  <CTableDataCell>${record.total}</CTableDataCell>
                  <CTableDataCell> {record.add_score_block == 1 ? 'Yes' : 'No'}</CTableDataCell>
                  <CTableDataCell>
                    <CBadge color={getBadge(record.status)}>
                      {record.status === 1
                        ? 'Approved'
                        : record.status === 2
                        ? 'Rejected'
                        : 'Pending'}
                    </CBadge>
                  </CTableDataCell>
                  <CTableDataCell>
                    {moment(record.created_at).format('D.MM.YYYY h:mm A')}
                  </CTableDataCell>
                  <CTableDataCell>
                    {/* <CButton
                      size="sm"
                      color="success"
                      className="ml-1"
                      onClick={() => handleStatus(record.id, 1)}
                    >
                      Approve
                    </CButton>
                    <CButton
                      size="sm"
                      color="danger"
                      className="ml-1"
                      onClick={() => handleStatus(record.id, 2)}
                    >
                      Reject
                    </CButton> */}
                    <CButton
                      size="sm"
                      color="info"
                      className="ml-1"
                      onClick={() => getGameRequestQuoteData(record?.id, record.game_id)}
                    >
                      Approve & View Quote
                    </CButton>
                  </CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
        </CCardBody>
      </CCard>
      {/* Modal for showing quote details */}
      {gameInfo?.game_type === 1 && (
        <ShowPricingQuotaModelForGame
          pricingQuoteVisibleModal={pricingQuoteVisibleModal}
          setPricingQuoteVisibleModal={setPricingQuoteVisibleModal}
          quoteRecordDetails={quoteRecordDetails}
          getPricingQuoteData={getPricingQuoteData}
        />
      )}
      {(gameInfo?.game_type === 2 || gameInfo?.game_type === 3) && (
        <ShowPricingQuotaModelForLeague
          pricingQuoteVisibleModal={pricingQuoteVisibleModal}
          setPricingQuoteVisibleModal={setPricingQuoteVisibleModal}
          quoteRecordDetails={quoteRecordDetails}
          getPricingQuoteData={getPricingQuoteData}
        />
      )}

      {/* Modal for quote details */}
      <CModal visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader onClose={() => setVisible(false)}>
          <strong>Quote Details</strong>
        </CModalHeader>
        <CModalBody>
          <div>
            <strong>Team Tier:</strong> {pricingRequestData.plan_name || '-'}
          </div>
          <div>
            <strong>Plan Duration:</strong> {pricingRequestData.duration || '-'}
          </div>
          <div>
            <strong>Plan Cost:</strong>{' '}
            {pricingRequestData.cost ? `$${pricingRequestData.cost}` : '-'}
          </div>
          <div>
            <strong>Add Score Block:</strong> {pricingRequestData.add_score_block ? 'Yes' : 'No'}
          </div>
          <div>
            <strong>Total:</strong>{' '}
            {pricingRequestData.total ? `$${pricingRequestData.total}` : '-'}
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisible(false)}>
            Close
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default GameQuoteRequest
